export default __webpack_public_path__ + "static/axios-hq-7ac7f85ab3845f46cdea7c0247adffdc.svg";